import angular from 'angular';

import RwMultistoreSelectorDialogModule from './components/rw-multistore-selector-dialog/rw-multistore-selector-dialog-module';

import RwMultistoreSelectorComponent from './rw-multistore-selector-component';

export default angular
  .module('rw-multistore-selector', [
    RwMultistoreSelectorDialogModule.name,
  ])
  .component('rwMultistoreSelector', new RwMultistoreSelectorComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-multistore-selector/rw-multistore-selector-module.js